window.addEventListener("lpstatechange", async (e) => {
  if (e.detail.state !== "agentblazerOpen") return;

  const { default: lottie } = await import("lottie-web");

  const animationConfig = {
    container: document.querySelector(".ab_data-dust-animation"),
    path: "/agentblazer/data-dust.json"
  };

  //todo set this to loop false
  const dataDust = lottie.loadAnimation({
    ...animationConfig,
    renderer: "svg",
    loop: false,
    autoplay: false
  });

  dataDust.play();
});
